<template>
    <settings-list-element
        style="margin-left: 23px !important; display: flex !important;"
        v-for="(element, index) in inputItems"
        :element="element"
        :key="(element as ColumnListItem).compound_id"
        :input-index="index"
        :parent-id="undefined"
        :parent-name="''"
        :parent-idx="(element as ColumnListItem).compound_id"
        :is-root="true"
        @changeSelection="onModelUpdate"
    />
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import DndListElement from '@/components/dnd/DndListElement.vue';
import SettingsListElement from '@/components/common/settings-list/SettingsListElement.vue';
import { ColumnSend, ColumnSendSelectable } from '@/models/interfaces/entity-settings/columns/columns';
import { reactive } from 'vue';
import { ColumnListItem } from '../base-list/interfaces/ListTypes';

@Component({
  name: 'AnalyticsSettingsList',
  components: { DndListElement, SettingsListElement }
})
export default class AnalyticsSettingsList extends Vue {
    @Prop({ default: [] as ColumnSend[] })
    inputItems!: ColumnSend[]

    @Emit("changeSelection") emitSelectionChanged(arg: any) { return arg }

    created() {
        //
    }

    onModelUpdate(arg: any) {
      this.emitSelectionChanged(arg)
    }
}
</script>